import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import Loader from "../../../../Loader/Loader/Loader.js";
/* empty css           */
import { isTouchDevice } from "../../../../Util/Util/is-touch-device.js";
const handleOnClear = (ref, callback) => {
  callback();
  ref?.current?.focus();
};
const handleOnSubmit = (ref, callback) => {
  callback?.();
  if (isTouchDevice() === false) {
    ref?.current?.focus();
  }
};
const Input = React.forwardRef(
  ({
    className,
    count,
    cursor,
    disabled,
    isInvalid,
    isListSuggestionsOpen,
    isValid,
    labels,
    loading,
    name,
    onBlur,
    onChange,
    onClear,
    onClick,
    onSubmit,
    placeholder,
    showClearButton = false,
    submitIcon,
    type,
    value,
    ...rest
  }, ref) => {
    const status = React.useMemo(
      () => isListSuggestionsOpen && count > 0 ? `${count} ${labels.availableResultsScreenReaderHint}` : labels.noAvailableResultsScreenReaderHint,
      [count, labels, isListSuggestionsOpen]
    );
    return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("autocomplete-input", className) }, /* @__PURE__ */ React.createElement("span", { id: `${name}-autocomplete-description`, className: "autocomplete-input__hint" }, labels.inputScreenReaderHint), status && /* @__PURE__ */ React.createElement("span", { role: "status", "aria-live": "assertive", className: "autocomplete-input__hint--hidden" }, status), /* @__PURE__ */ React.createElement(
      "input",
      {
        "aria-activedescendant": cursor < 0 ? void 0 : `autocomplete-suggestion-item-${cursor}`,
        "aria-autocomplete": "both",
        "aria-describedby": `${name}-autocomplete-description`,
        "aria-expanded": isListSuggestionsOpen,
        "aria-label": name,
        "aria-owns": `${name}-suggestions`,
        "aria-controls": `${name}-suggestions`,
        autoComplete: "off",
        className: classnames("autocomplete-input__input", {
          "autocomplete-input__input--extra-padding": showClearButton || loading,
          _is_invalid: isInvalid,
          _is_valid: isValid
        }),
        "data-t": name,
        disabled,
        id: name,
        name,
        onBlur,
        onChange,
        onClick,
        placeholder,
        ref,
        role: "combobox",
        type,
        value,
        "aria-invalid": !isValid
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "autocomplete-input__button-wrapper" }, loading ? /* @__PURE__ */ React.createElement(Loader, { className: "autocomplete-input__loader" }) : showClearButton && /* @__PURE__ */ React.createElement(
      "button",
      {
        "aria-label": labels.clearButtonScreenReaderHint,
        type: "button",
        onClick: () => handleOnClear(ref, onClear),
        className: "autocomplete-input__button autocomplete-input__button--clear"
      },
      /* @__PURE__ */ React.createElement(Icon, { name: "clear" })
    ), submitIcon && /* @__PURE__ */ React.createElement(
      "button",
      {
        "aria-label": labels.submitButtonScreenReaderHint,
        type: "button",
        onClick: () => handleOnSubmit(ref, onSubmit),
        className: "autocomplete-input__button autocomplete-input__button--submit"
      },
      submitIcon
    )));
  }
);
export {
  Input as default
};
//# sourceMappingURL=Input.js.map
